import CustomButton from "../../../../components/CustomButton";
import userRoles from "../../../../constants/userRoles";
import { getDownloadDevice } from "../../../../redux/api/admin.api";
import { useAppDispatch } from "../../../../redux/hooks";
import { adminRoutes, crudRoutes } from "../../../../router/routesConstants";
import usePermissions from "../../../../router/usePermissions";
import Text from "../../../../styleguide/Text";

function DevicesNomenclatureCustomHeader() {
  const { isAuthorized } = usePermissions();
  const dispatch = useAppDispatch();

  const goToCreateDevicesNomenclature = () => {
    return `/${adminRoutes.devicesNomenclature}/${crudRoutes.create}`;
  };

  const handleDownloadDevice = async () => {
    await dispatch(getDownloadDevice({ idDevice: "model" }));
  };

  return (
    <div className="flex flex-wrap justify-between items-center gap-3 mb-6">
      <Text
        variant="h3"
        component="h3"
        className="font-semibold text-slate-900">
        Nomenclator echipamente
      </Text>
      <div className="flex flex-wrap items-center justify-end gap-3">
        <CustomButton
          variant="contained"
          icon="DOWNLOAD"
          tooltipTitle="Descarca modelul documentului pentru dispozitive."
          onClick={handleDownloadDevice}>
          Descarca model
        </CustomButton>
        {isAuthorized(userRoles.DEVICES_NOMENCLATURE_CREATE) && (
          <CustomButton
            variant="contained"
            icon="ADD"
            tooltipTitle="Deschide formularul de adaugare a unui dispozitiv."
            navigate={goToCreateDevicesNomenclature()}>
            Adauga dispozitiv
          </CustomButton>
        )}
      </div>
    </div>
  );
}

export default DevicesNomenclatureCustomHeader;
